export const INTIIAL_VALUES = { 
	hiring: [],
	college: [],
	dna: []
};
  